export type DocumentsStatus = 'InReview' | 'Approved' | 'Requested' | 'Rejected'

export type DocumentFile = {
  supplierDocumentType: keyof typeof DocumentType
  documentDisplayName: string
  documentKey: string
  fileLink: string
  createdDate: string
  documentStatus: DocumentsStatus
  modifiedDate?: string
  isArchived?: boolean
}

export type DocumentGroup = {
  files: DocumentFile[]
  status: DocumentsStatus
  date?: string
}

export type DocumentsResponse = {
  groups: DocumentGroup[]
}

export const DocumentType = {
  Agreement: 'agreements',
  RegistrationCertificate: 'registrationCertificates',
  SignatureAuthority: 'signatureAuthorities',
  PassportOrIdCard: 'passportOrIdCard',
} as const
